// Replace a host's HTML ONLY when it actually changed. Panels that re-render on every income tick would otherwise
// rebuild their buttons several times a second — and a real mouse click (mousedown on one node, mouseup on its
// replacement) is silently lost. Returns true if the DOM was replaced, so callers (re)wire handlers only then.
export function setHtmlIfChanged(host, html) {
  if (host.__lastHtml === html) return false
  host.__lastHtml = html
  host.innerHTML = html
  return true
}

// A small "×" for any message that can linger, so it can always be closed. `el` should be positioned (relative / absolute / fixed):
// the button sits in its top-right corner (see .msg-close in hud.css). onClose() does the hiding. Returns the button.
export function addCloseButton(el, onClose, label = 'Close this message') {
  const b = document.createElement('button')
  b.type = 'button'
  b.className = 'msg-close'
  b.setAttribute('aria-label', label)
  b.title = 'Close'
  b.textContent = '×'
  b.addEventListener('click', (e) => { e.stopPropagation(); onClose() })
  el.appendChild(b)
  return b
}
